import { createReducer } from 'app/state/utils'
import { FundGroup } from 'app/models/fund-group'
import * as types from './types'

export interface FundGroupsState {
  /** Every group the backend let the caller see (all Public + own Private), all fund managers. */
  groups: FundGroup[]
  isLoading: boolean
}

const initialState: FundGroupsState = {
  groups: [],
  isLoading: false,
}

const byName = (a: FundGroup, b: FundGroup) =>
  a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })

const reducer = createReducer(initialState)({
  // Wholesale replace: the backend already applied visibility, and a group deleted by another
  // user must disappear on the next load. Failed loads never dispatch here.
  [types.LOAD_FUND_GROUPS]: (state: FundGroupsState, action: any) => ({
    ...state,
    groups: [...(action.payload ?? [])].sort(byName),
  }),
  // Scoped replace: the trade editor loads one manager's groups; a group of that manager that
  // another user deleted disappears, other managers' groups are kept.
  [types.LOAD_FUND_GROUPS_FOR_MANAGER]: (state: FundGroupsState, action: any) => {
    const { fundManagerId, groups } = action.payload ?? {}
    if (!fundManagerId) return state
    const others = state.groups.filter(g => g.fundManagerId !== fundManagerId)
    return { ...state, groups: [...others, ...((groups ?? []) as FundGroup[])].sort(byName) }
  },
  [types.UPSERT_FUND_GROUP]: (state: FundGroupsState, action: any) => {
    const incoming: FundGroup | undefined = action.payload
    if (!incoming) return state
    const rest = state.groups.filter(g => g.id !== incoming.id)
    return { ...state, groups: [...rest, incoming].sort(byName) }
  },
  [types.REMOVE_FUND_GROUP]: (state: FundGroupsState, action: any) => ({
    ...state,
    groups: state.groups.filter(g => g.id !== action.payload),
  }),
  [types.SET_FUND_GROUPS_LOADING]: (state: FundGroupsState, action: any) => ({
    ...state,
    isLoading: !!action.payload,
  }),
})

export default reducer
